import store from '@/store'
import {setAuthInHeader} from "@/api/request";
import util from '@/mixins/util';
import VueJwtDecode from 'vue-jwt-decode'
import {localStorageKey} from "@/api/config";
import { checkAccessPage,checkAccessPageRoute} from "@/service/adminAccessPage";
let wcsTimer = [];

export const getStorageToken = () => { // 토큰 가져오기
    //let token = Vue.$jwt.getToken();
    let token = window.localStorage.getItem(localStorageKey + 'token');
    let regex = /"/gi;
    if (!token) {
        return null;
    }
    let jwtToken = token.replace(regex, '');
    return jwtToken
}

export const getTokenObj = () => { // 토큰 가져오기
    let jwtToken = getStorageToken();
    if (jwtToken) {
        let token = jwtToken.replace(/-/g, "+").replace(/_/g, "/");
        let tokenObject = VueJwtDecode.decode(token);
        if (jwtToken && tokenObject) {
            return tokenObject;
        } else if (jwtToken) {
            return -1;
        } else {
            return null;
        }
    } else {
        return null;
    }

}

export const AuthCheck = () => { // 토큰이 로컬스토리지에 담겼을 시 사용
    let tokenObj = getTokenObj();
    if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
        return 1;
    } else if (tokenObj == -1) { //토큰값이 다를경우 토큰 지우고 null
        logout();
        return null;
    } else {
        return null;
    }
};

function getSuccess(storeSet, storeCount) {
    let finishCount = 0;
    let success = false;
    return function () {
        util.Array.each(storeSet, (item, index, storeSet) => {
            if (item.status == 'finish') {
                finishCount++
            }
        });
        success = (storeCount == finishCount) ? true : false
        return success;
    };
}

export const StoreProcess = (to, from, next) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    //스토어가 필수 조건이 아니면 진행
    if (!to.meta.storeRequired) {
        next();
    }
    let params = to.params;
    let query = to.query;
    let configs = to.meta.storeConfig;
    let accessIdx = to.meta.accessIdx || '';

    let storeSet = [];
    let wcsTimerCnt = 0;
    util.Object.each(configs, (index, value, configs) => {
        if (value) {
            let obj = {
                'name': index,
                'required': value,
                'params': params,
                'query': query,
                'status': 'ready',
                'try': 0,
                'max': 8,   //max는 5을 넘을 수 없습니다.
                'accessIdx': accessIdx,
            }
            storeSet.push(obj)
        }
    });

    let storeCount = storeSet.length;
    let isSuccess = storeCheck(storeSet, next)
    if (isSuccess) {
        // clearInterval(wcsTimer);
        removeAllInterval();
        next();
        return false;
    }
    let wcsTimers = setInterval(function () {
        if (wcsTimerCnt <= 8) { // 0.5초 동안 리트라이 총 시도 횟수
            let isSuccess = storeCheck(storeSet, next)
            if (isSuccess) {
                // clearInterval(wcsTimer);
                removeAllInterval();
                next();
            }
            wcsTimerCnt++;
        } else {
            clearInterval(wcsTimer);
            next('/')
        }
    }.bind(this), 500);
    wcsTimer.push(wcsTimers);
};

function storeCheck(storeSet, next) {
    let storeCount = storeSet.length;
    util.Array.each(storeSet, (item, index, storeSet) => {
        if (item.status != 'finish') {
            item = storeRunning(item);
        }
        if (item.status === 'logout') {
            removeAllInterval();
            next('/auth');
            logout();
        }
        if (item.name == 'userInfo' && item.status == 'fail') {
            removeAllInterval();
            next('/auth');
        } else if (item.name == 'checkAccess') {
            return AuthCheckAccess(item);
        } else if (item.name == 'setSoData' && item.status == 'fail') {
            // clearInterval(wcsTimer);
            removeAllInterval();
            next('/auth');
        } else if (item.name == 'checkFinish' && item.status == 'fail') {
            removeAllInterval();
            next('/auth');
        } else if (item.status == 'fail') {  //하나라도 실패할 경우 인증으로
            removeAllInterval();
            next('/')
        }
    });

    let isSuccessFn = getSuccess(storeSet, storeCount);  //클로저 형태로 펑션을 리턴합니다. 펑션자체에 if 걸지마세요 항상 true입니다.
    let isSucess = isSuccessFn();
    return isSucess;
};

function removeAllInterval() {
    for (let i = 0; i < wcsTimer.length; i++) {
        clearInterval(wcsTimer[i]);
    }
    wcsTimer = [];
}

function storeRunning(storeItem) {
    if (storeItem.name == 'userInfo') {
        return AuthPayLoad(storeItem);
    } else if (storeItem.name == 'checkAccess') {
        return AuthCheckAccess(storeItem);
    } else if (storeItem.name == 'setSoInfo') {
        return setSoInfo(storeItem);
    } else if (storeItem.name == 'setOneDepth') {
        return setOneDepth(storeItem);
    } else if (storeItem.name == 'checkAccessRoute') {
        return AuthCheckAccessRoute(storeItem);
    } else {
        return storeItem
    }


}


export const AuthPayLoad = (storeItem) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }

    if (store.getters['userInfo/getUserInfo'] != undefined && store.getters['userInfo/getUserInfo'].mb_no) {
        //프로필 수정 페이지에서 프로필 값이 미입력일 경우 RouteLeave 를 못시키는 방향으로.
        storeItem.status = 'finish'
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = 'fail'
        } else {
            storeItem.status = 'run'
            storeItem.try++;
        }
    }
    return storeItem;
};
export const setSoInfo = async (storeItem) => {
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }
    if (store.getters["soInfo/getSoInfo"].length > 0) {
        storeItem.status = "finish";
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = "fail";
        } else {
            storeItem.status = "run";
            storeItem.try++;
        }
    }
    return storeItem;
};

export const AuthCheckAccessRoute = (storeItem) => {
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }
    if (storeItem.status === 'fail' || storeItem.status === 'finish') {
        return storeItem;
    }

    if (store.getters['userInfo/getUserInfo'] !== undefined && store.getters['userInfo/getUserInfo'].mbNo) {
        //프로필 수정 페이지에서 프로필 값이 미입력일 경우 RouteLeave 를 못시키는 방향으로.
        let openAlert = true;
        if (storeItem.query.login) {
            openAlert = false;
        }
        let checkAccess = checkAccessPageRoute(storeItem.accessRoute, openAlert);
        if (checkAccess.status) {
            storeItem.status = 'finish';
        } else if (store.getters['userInfo/getUserInfo'].crmAuthority.isSuper === 0 && (util.isEmpty(store.getters['userInfo/getUserInfo'].crmAuthority) || store.getters['userInfo/getUserInfo'].crmAuthority.crmAccess !== 1)) {
            storeItem.status = 'logout';
            alert('접근가능한 페이지가 존재하지 않습니다.');
        } else {
            storeItem.status = 'fail';
            storeItem.movePage = checkAccess.route;
        }
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = 'fail'
        } else {
            storeItem.status = 'run'
            storeItem.try++;
        }
    }
    return storeItem;
}

export const AuthCheckAccess = (storeItem) => {
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }

    if (storeItem.status === 'fail' || storeItem.status === 'finish') {
        return storeItem;
    }


    if (store.getters['userInfo/getUserInfo'] != undefined) {
        let openAlert = true;
        if (storeItem.query.login) {
            openAlert = false;
        }
        let checkAccess = checkAccessPage(storeItem.accessIdx, openAlert);
        if (checkAccess.status) {
            storeItem.status = 'finish';
        } else if (store.getters['userInfo/getUserInfo'].cmsAuthority.isSuper === 0 && (util.isEmpty(store.getters['userInfo/getUserInfo'].cmsAuthority) || store.getters['userInfo/getUserInfo'].cmsAuthority.cmsAccess !== 1)) {
            storeItem.status = 'logout';
            alert('접근가능한 페이지가 존재하지 않습니다.');
        } else {
            storeItem.status = 'fail';
            storeItem.movePage = checkAccess.route;
        }
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = 'fail'
        } else {
            storeItem.status = 'run'
            storeItem.try++;
        }
    }
    return storeItem;
}

export const setSoData = async (storeItem) => {
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }
    if (store.getters["so/getSoData"].length > 0) {
        storeItem.status = "finish";
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = "fail";
        } else {
            storeItem.status = "run";
            storeItem.try++;
        }
    }
    return storeItem;
};
export const setOneDepth = async (storeItem) => {
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }
    if (store.getters["authority/getOneDepth"].length > 0) {
        storeItem.status = "finish";
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = "fail";
        } else {
            storeItem.status = "run";
            storeItem.try++;
        }
    }
    return storeItem;
};
export const storeSet = (to, from, next) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    if (to.matched.some(function (routeInfo) {
        return routeInfo.meta.storeRequired;
    })) {
        let jwtToken = getStorageToken();
        let tokenObj = getTokenObj();
        if (tokenObj === -1) {
            logout();
        }
        if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
            // 매번 최신 유저 정보를 가져와서 임시 비밀번호 체크
            store.dispatch('userInfo/setUserInfo', {token: jwtToken});

            let userInfoStatus = store.getters['userInfo/getUserInfo'].mb_no;
            if (!userInfoStatus) {
                store.dispatch('soInfo/setSoInfo');
                store.dispatch('authority/setOneDepth');
            }
            StoreProcess(to, from, next);
        } else {
            StoreProcess(to, from, next);
        }
    } else {
        next(); // 페이지 전환
    }
    ;
};

export const authPageCheck = (to, from, next) => { // 인증 페이지 설정.
    // to: 이동할 url에 해당하는 라우팅 객체
    let tokenObj = getTokenObj();
    if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
        next('/');
    } else {
        next();
    }
};


export const loginTokenSet = (token) => {
    //let token = window.localStorage.getItem(localStorageKey+'token');
    //Vue.$localStorage.set('token', token);
    window.localStorage.setItem(localStorageKey + 'token', '"' + String(token) + '"');
    setAuthInHeader(token);
}

export const logout = ($this = null) => {
    //Vue.$localStorage.clear();
    window.localStorage.clear();
    setAuthInHeader('');
    //history.replaceState(null, null, '/')

    if ($this) {
        $this.$router.replace('/auth');
        // location.replace('/auth');
    } else {
        //location.href = '/'
        location.replace('/');
    }
    // location.href = '/#/auth';
}
